var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const truncateReactChildren = (children, maxLength) => {
  if (!children) {
    return [null, maxLength];
  }
  if (typeof children === "string") {
    const len = children.length;
    maxLength -= len;
    if (maxLength <= 0) {
      children = children.substr(0, children.length + maxLength);
    }
    return [children, maxLength];
  }
  function track(el) {
    if (maxLength > 0) {
      const len = el.length;
      maxLength -= len;
      if (maxLength <= 0) {
        el = el.substr(0, el.length + maxLength);
      }
    } else {
      el = void 0;
    }
    return el;
  }
  function walk(children2, fn) {
    var _a, _b;
    let props = __spreadValues({}, children2.props);
    if (typeof props.children === "string") {
      props.children = track(children2.props.children);
    } else {
      props.children = (_a = children2.props.children) == null ? void 0 : _a.map((child) => {
        if (typeof child === "object") {
          child = walk(child, fn);
        } else if (typeof child === "string") {
          child = fn(child);
        }
        return child;
      });
    }
    if (!props.children) {
      children2 = void 0;
      props = void 0;
    }
    if (children2 && typeof children2 !== "string" && props.children && typeof props.children !== "string") {
      props.children = (_b = props.children) == null ? void 0 : _b.filter((child) => child);
    }
    return children2 && props ? __spreadProps(__spreadValues({}, children2), { props }) : void 0;
  }
  try {
    const upperlevelProps = walk(__spreadValues({}, children), track);
    return [__spreadValues({}, upperlevelProps), maxLength];
  } catch (er) {
    return [null, maxLength];
  }
};

export { truncateReactChildren };
//# sourceMappingURL=helpers.es.js.map
